import { ClerkProvider, SignedIn, SignedOut } from '@clerk/clerk-react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Layout from './layout/layout';
import { MainAppRoutes, OnboardingRoutes, PublicRoutes } from './pages/Pages';

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;
const queryClient = new QueryClient();

function App() {
  return (
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          {/* Protected routes */}
          <SignedIn>
            <Routes>
              <Route path="/onboard" element={<OnboardingRoutes />} />
              <Route
                path="/*"
                element={
                  <Layout>
                    <MainAppRoutes />
                  </Layout>
                }
              />
            </Routes>
          </SignedIn>

          {/* Public routes */}
          <SignedOut>
            <PublicRoutes />
          </SignedOut>
        </BrowserRouter>
      </QueryClientProvider>
    </ClerkProvider>
  );
}

export default App;
